import React, { useState } from 'react';
import { InternalApiTransliterationRequestFeaturesEnum } from '../api-internal';
import { SalvButton, SalvDropdown, SalvFieldHeader, SalvTextArea } from '@salvapp/ui-components';
import { transliterationApi } from '../apis';
import SalvPage from '../common/SalvPage';

export const Transliterator = () => {
  const [text, setText] = useState('');
  const [result, setResult] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [features, setFeatures] = useState<InternalApiTransliterationRequestFeaturesEnum[]>([]);

  const handleTransliterate = async () => {
    if (!text.trim()) return;

    setIsLoading(true);
    try {
      const response = await transliterationApi.transliterate({
        internalApiTransliterationRequest: {
          text,
          features,
        },
      });
      setResult(response.transliterated);
    } catch (error) {
      console.error('Transliteration failed:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <SalvPage title={'Transliteration Sandbox'}>
      <div style={{ display: 'flex', gap: '16px' }}>
        <div style={{ flex: '1 1 0' }}>
          <SalvTextArea
            label={'Text to transliterate'}
            value={text}
            onChange={(value) => setText(value)}
            placeholder='Enter text to transliterate...'
            autoSizing
            className={'m-b-8'}
          />

          <SalvDropdown
            label={'Features'}
            options={featuresOptions}
            isMulti
            value={featuresOptions.filter((option) => features.includes(option.value))}
            onChange={(values) =>
              setFeatures(values.map((v) => v.value as InternalApiTransliterationRequestFeaturesEnum))
            }
            className={'m-b-8'}
          />

          <SalvButton label={'Transliterate'} onClick={handleTransliterate} disabled={!text.trim() || isLoading} />
        </div>
        <div style={{ flex: '1 1 0' }}>
          {result && (
            <>
              <SalvFieldHeader label={'Transliteration result'} />
              <div>{result}</div>
            </>
          )}
        </div>
      </div>
    </SalvPage>
  );
};

const featuresOptions = Object.values(InternalApiTransliterationRequestFeaturesEnum).map((feature) => ({
  key: feature,
  value: feature,
  label: feature,
}));

export default Transliterator;
